import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, OverlayTrigger, Row, Col, Alert } from "react-bootstrap";
import {
  Button,
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import ButtonIcon from "../../common/ButtonIcon";
import APICall from "../../../services/apiCall";
import SikkaCardHeader from "../../common/SikkaCardHeader";
import {
  faCancel,
  faSave,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import AppContext from "../../../context/Context";
import APIPortalTable from "../../common/Table/APIPortalTable";
import AddNewPaymentUpdateModal from "../../ModalPopup/AddNewPaymentUpdateModal";
import apiCall from "../../../services/apiCall";
function arraysNotEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return true;

  // Sort both arrays
  const sortedArr1 = arr1.slice().sort();
  const sortedArr2 = arr2.slice().sort();

  // Compare the sorted arrays
  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) return true;
  }
  return false;
}
function arraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;

  // Sort both arrays
  const sortedArr1 = arr1.slice().sort();
  const sortedArr2 = arr2.slice().sort();

  // Compare the sorted arrays
  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) return false;
  }
  return true;
}
const PaymentLiveUpdateConfiguration = ({
  appid,
  isActionAllowed,
  applicationDetails,
  applicationList,
  partnerCustomerListForLiveUpdate,
}) => {
  //const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [updateDataFlag, setUpdateDataFlag] = useState(true);
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [noSearchCustomers, setNoSearchCustomers] = useState(false);
  const [customerRowSelection, setCustomerRowSelection] = useState({});
  const [allStatus, setAllStatus] = useState(false);
  const [currentActiveLocation, setCurrentActiveLocation] = useState([]);
  const [originalActiveLocation, setOriginalActiveLocation] = useState([]);
  const [originalAllStatus, setOriginalAllStatus] = useState(false);
  const materialColumns = [
    {
      accessorKey: "rawid", //simple recommended way to define a column
      header: "Row ID",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: false,
      Cell: ({ cell }) => <span>{
        cell.getValue() == "new" ?
          (<OverlayTrigger
            placement="top"
            delay={{ show: 200, hide: 200 }}
            overlay={
              <Tooltip id={"mpAccessFlag" + cell.getValue()}>
                This Masterid is not saved yet
              </Tooltip>
            }
          >
            <Button
              id="btnOnAc"
              size="sm"
              className={"btn btn-xs btn-success"}
            >
              New
            </Button>
          </OverlayTrigger>)
          : (
            cell.getValue()
          )
      }</span>, //optional custom cell render
    },
    {
      accessorKey: "master_id", //simple recommended way to define a column
      header: "Master Id",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: false,

      Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
    },
    {
      accessorKey: "app_environment", //simple recommended way to define a column
      header: "Environment",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: false,

      Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
    },
    {
      accessorKey: "status", //simple recommended way to define a column
      header: "status",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: false,
      Cell: ({ cell }) => <span>{cell.getValue()}</span>, //optional custom cell render
    },
    {
      accessorKey: "master_id", //simple recommended way to define a column
      header: "Delete",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: false,
      Cell: ({ row }) => {
        return (
          <ButtonIcon
            color="falcon-danger"
            size="sm"
            icon="trash"
            iconClassName="fs--2"
            className="mx-1 mt-2 mt-lg-0"
            onClick={() => {
              currentActiveLocation.splice(row.index, 1);
              setCurrentActiveLocation([...currentActiveLocation])
            }}
          >
          </ButtonIcon>
        );
      },
    },
  ];;

  const { loginUserDetails } = useContext(AppContext);


  useEffect(() => {
    if (appid && updateDataFlag) {
      setLoading(true);
      var apiParam = { app_id: appid };
      APICall.servertrip(
        "GET",
        "payment_app_live_update_configuration",
        loginUserDetails,
        apiParam
      ).then(
        (res) => {
          setCurrentActiveLocation(
            res.data.items.map((data, index) => ({ ...data, id: index }))
          );
          setOriginalActiveLocation(
            res.data.items.map((data, index) => ({ ...data, id: index }))
          );
          setLoading(false);
          setOriginalAllStatus(res.data.all_status == "active")
          setAllStatus(res.data.all_status == "active")
          setUpdateDataFlag(false);
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setLoading(false);
          toast.error(resMessage);
          setUpdateDataFlag(false);
        }
      );
    } else {
      setLoading(false);
    }
  }, [appid, updateDataFlag]);



  const UpdateRefreshLocation = () => {
    let currentSelectedMasterId = currentActiveLocation.map((x) => {
      return x.master_id
    }).sort();
    let originalMasterId = originalActiveLocation.map((x) => {
      return x.master_id
    }).sort();
    if (arraysNotEqual(originalMasterId, currentSelectedMasterId) || originalAllStatus != allStatus) {

      var body = {
        "app_id": appid,
        "all_status": allStatus ? "active" : "inactive",
        "master_id": currentSelectedMasterId.join(",")
      }
      apiCall.servertrip("POST", "payment_app_live_update_configuration", undefined, undefined, body).then(
        (res) => {
          setUpdateDataFlag(true)
          toast.success("Updated Successfully !!");
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          toast.error(resMessage);
        }
      );
    }

    else {
      toast.warn("No changes made!")
    }

  };
  useEffect(() => {
    if (allStatus) {

    }
  }, [allStatus])
  return (
    <Fragment>
      <Card className="mb-3">
        <div>
          <SikkaCardHeader title="Live Update Configuration" light={true}>
            <div className="d-flex flex-wrap flex-sm-nowrap">
              <OverlayTrigger
                placement="top"
                delay={{ show: 200, hide: 200 }}
                overlay={
                  <Tooltip id={"Alllocation"}>
                    Click here to set live updates on for all customers.
                  </Tooltip>
                }
              >
                <Button
                  color={allStatus ? "falcon-success" : "falcon-secondary"}
                  size="sm"
                  icon="Sync"
                  className="ml-1 mt-lg-0 mb-2"
                  onClick={() => {
                    setAllStatus(true)
                  }}
                >
                  All location
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                delay={{ show: 200, hide: 200 }}
                overlay={
                  <Tooltip id={"Selectedlocation"}>
                    Click here to set live updates on for selected customers only.
                  </Tooltip>
                }
              >
                <Button
                  color={allStatus ? "falcon-secondary" : "falcon-success"}
                  size="sm"
                  icon="Sync"
                  className="ml-1 mt-lg-0 mb-2"
                  iconClassName="fs--2"
                  onClick={() => {
                    setAllStatus(false)
                  }}
                >
                  Selected location
                </Button>
              </OverlayTrigger>

              <ButtonIcon
                color="outline-primary"
                size="sm"
                icon="Sync"
                className="ml-1 mt-lg-0 mb-2"
                iconClassName="fs--2"
                onClick={() => {
                  setUpdateDataFlag(true)
                }}
              >
                <FontAwesomeIcon style={{ marginRight: "5px" }} icon={faSync} />
                Refresh
              </ButtonIcon>
              {!allStatus &&
                applicationList.length > 0 && (
                  <ButtonIcon
                    icon="plus"
                    transform="shrink-3 down-2"
                    color="outline-primary"
                    size="sm"
                    className="mx-1 mt-lg-0 mb-2"
                    onClick={() => setAddCustomerModal(true)}
                  >
                    Customer
                  </ButtonIcon>
                )}
            </div>
          </SikkaCardHeader>

          <CardBody className="p-0">
            {!allStatus ? <APIPortalTable
              data={currentActiveLocation}
              columns={materialColumns}
              loading={loading}
              enableRowAction={true}
              enablePagination
              CSVFileName={`${applicationDetails.app_name
                }_PaymentLiveUpdateConfiguration${new Date().getMonth() +
                1}/${new Date().getDate()}/${new Date().getFullYear()}.csv`}
            /> :
              (<Alert className="alert alert-success m-3 p-3" role="alert">
                Updates will be applied to all location
              </Alert>)}
            <ModalFooter className="d-flex text-right">
              <Col className="text-left ">
                <b>Note :</b>
                <p>
                  All your changes will be saved after you click on the save
                  button.
                </p>
              </Col>
              <ButtonIcon
                icon={faSave}
                transform="shrink-3 down-2"
                color="outline-success"
                size="sm"
                onClick={() => {
                  UpdateRefreshLocation()
                }}
              >
                Save
              </ButtonIcon>

              <ButtonIcon
                icon={faCancel}
                transform="shrink-3 down-2"
                color="outline-danger"
                size="sm"
                onClick={() => {
                  setUpdateDataFlag(true)
                }}
              >
                Cancel
              </ButtonIcon>
            </ModalFooter>
          </CardBody>
        </div>
      </Card>
      <Modal
        size="xl"
        isOpen={addCustomerModal}
        toggle={() => {
          setAddCustomerModal(false);
        }}
        onClosed={() => {
          setAddCustomerModal(false);
        }}
        scrollable={true}
        centered
        autoFocus={false}
      >
        <ModalHeader
          toggle={() => {
            setAddCustomerModal(!addCustomerModal);
          }}
        >
          Add MasterCustomerID
        </ModalHeader>
        <ModalBody className="fs--1 font-weight-normal">
          <AddNewPaymentUpdateModal
            noSearchCustomers={noSearchCustomers}
            partnerCustomerListForLiveUpdate={partnerCustomerListForLiveUpdate}
            rowSelection={customerRowSelection}
            setRowSelection={setCustomerRowSelection}
            currentActiveLocation={currentActiveLocation}
          />
        </ModalBody>
        <ModalFooter className="d-flex text-right">
          <Button
            size="sm"
            className="sm ml-auto mr-1"
            color="outline-success"
            onClick={() => {
              var selectedLocation = Object.keys(customerRowSelection).filter((key) => {
                return customerRowSelection[key] == true
              })
              var tempArray = []
              if (selectedLocation.length > 0) {
                partnerCustomerListForLiveUpdate?.map((location) => {
                  if (selectedLocation.includes(location.master_customer_id)) {
                    var tempObj = {
                      "rawid": "new",
                      "master_id": location.master_customer_id,
                      "payment_provider": "Nada Payments",
                      "app_version": "2.0.7.7",
                      "app_environment": location.is_demo_practice == "1" ? "Q" : "P",
                      "machine_name": "Pratik-Patel-Axar",
                      "status": "--",
                      "id": location.id
                    }
                    tempArray.push(tempObj)
                  }
                })
                setCurrentActiveLocation([...currentActiveLocation, ...tempArray]);
                setCustomerRowSelection({})
                setAddCustomerModal(false);
                setNoSearchCustomers(false);

              }
              else {
                toast.warn("No changes made!")
              }

            }}
          >
            Add
          </Button>
          <Button
            size="sm"
            color="outline-danger"
            onClick={() => {
              setCustomerRowSelection({})
              setAddCustomerModal(false);
              setNoSearchCustomers(false);
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default PaymentLiveUpdateConfiguration;
